import React from "react";
import style from "./QuoteSoftwareItems.module.css";
import { formatMoney } from "accounting-js";
import IconDelete from "./IconDelete";
import { connect } from "react-redux";
import { deleteQuoteItem, setQuoteItemQty } from "../redux/actions";
import IconSuccess from "./IconSuccess";
import IconWarning from "./IconWarning";
import { Badge, Button, Table } from "react-bootstrap";
import QuantityInput from "./QuantityInput";

function QuoteSoftwareItems({
  softwareItems,
  deleteQuoteItem,
  setQuoteItemQty,
  itemValidationMap,
  backendValidationMessages
}) {
  return softwareItems.length ? (
    <Table className={style.root} variant="sm" bordered>
      <thead>
        <tr>
          <th className={style.name}>Product</th>
          <th className={style.availability}>Availability</th>
          <th className={style.msp}>Minimum Sell Price (MSP)</th>
          <th className={style.targetPrice}>Target Price</th>
          <th className={style.qty}>Quantity</th>
          <th className={style.lineTotal}>Target Line Total</th>
          <th className={style.actions}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {softwareItems.map(item => {
          const isAvailable = !itemValidationMap.some(
            validationItem =>
              Number(validationItem.productId) === Number(item.productId)
          );
          const backendValidationErrors = backendValidationMessages.filter(err => err.id === item.key && err.selectionIds.length === 0);

          return (
            <React.Fragment key={item.key}>
            <tr>
              <td>
                {item.name}
                {item.excludeFromMarginSplit && (
                  <Badge variant="danger">Excluded from margin splitting</Badge>
                )}
              </td>
              <td className="text-center">
                {isAvailable ? <IconSuccess /> : <IconWarning />}
              </td>
              <td>{formatMoney(Number(item.price))}</td>
              <td>{formatMoney(Number(item.targetPrice))}</td>
              <td>
                <QuantityInput
                  className="form-control"
                  value={item.qty}
                  onConfirm={e => setQuoteItemQty(item, e.target.value)}
                />
              </td>
              <td>{formatMoney(item.targetPrice * item.qty)}</td>
              <td>
                <Button
                  variant="link"
                  onClick={e => {
                    e.preventDefault();
                    deleteQuoteItem({ key: item.key });
                  }}
                >
                  <IconDelete />
                </Button>
              </td>
            </tr>
            {
              backendValidationErrors.map((err, index) => 
                <tr key={`${err.id}-${index}`}>
                  <td className="alert-danger" colSpan="10">{err.errorMessage}</td>
                </tr>
              )
            }
            </React.Fragment>
          );
        })}
      </tbody>
    </Table>
  ) : null;
}

export default connect(
  state => ({
    itemValidationMap: state.quote.itemValidationMap,
    backendValidationMessages: state.quote.backendValidationMessages
  }),
  {
    deleteQuoteItem,
    setQuoteItemQty
  }
)(QuoteSoftwareItems);
